import { FormElement } from "./FormElement";
import { DOMTemplate } from "../../denki";
import { node } from "../Util";
import { FieldInputElement } from "./FieldInputElement";

export class FormNumberElement extends FormElement implements FieldInputElement {
  public id: string;
  disabled: boolean;
  validationErrors: string[];
  public readonly fieldsElement: HTMLElement;
  public readonly prefixElement: HTMLLabelElement;
  public readonly suffixElement: HTMLLabelElement;
  public readonly numberElement: HTMLInputElement;
  private _min?: number;
  private _max?: number;
  private _initialValue: number = 0;

  constructor(namespace: string, name: string, template: DOMTemplate) {
    super(template.get("field-element"));
    this.fieldsElement = this.element.querySelector("[data-role=elements]");
    const id = `${namespace}-${name}`;
    this.id = id;
    const attributes = {
      type: 'text',
      'data-id': id,
      name,
      'readonly': 'true',
      placeholder: "0",
      style: "pointer-events: none"
    };
    let numberElement = node('input', attributes);
    this.numberElement = numberElement;

    const fieldset = node('div', { class: 'input-number' });
    fieldset.appendChild(this.prefixElement = node('label', {}, ""));
    fieldset.appendChild(numberElement);
    fieldset.appendChild(this.suffixElement = node('label', {}, ""));
    let crementWrapper = node('div');
    const decrementButton = node('button', { class: 'decrementButton' }, 'ー');
    decrementButton.addEventListener('click', () => {
      this.decrement();
    });
    crementWrapper.appendChild(decrementButton);
    const incrementButton = node('button', { class: 'incrementButton' }, '＋');
    incrementButton.addEventListener('click', () => {
      this.increment();
    });
    crementWrapper.appendChild(incrementButton);
    fieldset.appendChild(crementWrapper);
    this.fieldsElement.appendChild(fieldset);
  }

  public get min() {
    return this._min;
  }

  public set min(min: number | undefined) {
    this._min = min;
  }

  public get max() {
    return this._max;
  }

  public set max(max: number | undefined) {
    this._max = max;
  }

  public get initialValue() {
    return this._initialValue;
  }

  public set initialValue(initialValue: number) {
    this._initialValue = initialValue;
    this.numberElement.placeholder = String(initialValue);
  }

  public increment() {
    const numberElement = this.numberElement;
    const currentValue = parseInt(numberElement.value);
    if (isFinite(currentValue)) {
      if (isFinite(this._max)) {
        if (this._max > currentValue) {
          numberElement.value = String(currentValue + 1);
        }
      } else {
        numberElement.value = String(currentValue + 1);
      }
    } else {
      numberElement.value = String(this._initialValue);
    }
    this.value = numberElement.value;
  }

  public decrement() {
    const numberElement = this.numberElement;
    const currentValue = parseInt(numberElement.value);
    if (isFinite(currentValue)) {
      if (isFinite(this._min)) {
        if (this._min < currentValue) {
          numberElement.value = String(currentValue - 1);
        }
      } else {
        numberElement.value = String(currentValue - 1);
      }
    } else {
      numberElement.value = String(this._initialValue);
    }
    this.value = numberElement.value;
  }

  public focus() {
    this.numberElement.focus();
  }
}